import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../login/auth.service';
import { Provider, UpdateProviderDto, UpdateUploadSettingsDto } from 'src/typings';

export interface CreateProviderDto {
  description: string;
  fullDescription?: string;
  taxNum?: string;
  orgNum?: string;
}

export class SearchProviderDto {
  id?: number;

  description?: string;

  taxNum?: string;

  orgNum?: string;

  limit?: number;

  offset?: number;

  order_active?: string;

  order_direction?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProviderService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  getOne(id: number) {
    return this.http.get<Provider>(`${environment.BACKEND}/provider/${id}`);
  }

  getAllProviders() {
    return this.http.get<Provider[]>(`${environment.BACKEND}/provider/list`);
  }

  create(payload: CreateProviderDto | string) {
    return this.http.post<Provider>(`${environment.BACKEND}/provider/create`,
      typeof payload === 'string' ? { description: payload } : payload);
  }

  save(payload: UpdateProviderDto) {
    return this.http.put(`${environment.BACKEND}/provider/update`, payload);
  }

  resetBalance(id: number) {
    return this.http.put(`${environment.BACKEND}/provider/reset_balance/${id}`, null);
  }

  search(payload?: SearchProviderDto) {
    return this.http.post<{ count: number; data: Provider[] }>(
      `${environment.BACKEND}/provider/search`,
      payload
    );
  }

  updateUploadSettings(payload: UpdateUploadSettingsDto) {
    return this.http.post(`${environment.BACKEND}/provider/update_upload_settings`, payload);
  }
}
